import { customElement, FASTElement } from '@microsoft/fast-element';
import { InfoIconTemplate as template } from './info-icon.template';
import { InfoIconStyles as styles } from './info-icon.styles';

@customElement({
  name: 'info-icon',
  template,
  styles,
})

/**
 * Circled i icon
 *
 */
export class InfoIcon extends FASTElement {
}
